import type { TranslateFn } from "../../i18n";

/**
 * Mobile-only bottom tab bar shared between BasicsStepMobile (mode="manual")
 * and the photo upload step (mode="scan"). Tapping the inactive tab calls
 * the corresponding switch handler — the parent decides what step to advance
 * to.
 */

function RulerIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="13" height="13">
      <path d="M3 17l6 6 12-12-6-6z" />
      <path d="M9 11l2 2M11 9l2 2M13 7l2 2M7 13l2 2" />
    </svg>
  );
}

function ScanIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="13" height="13">
      <path d="M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export interface MobileBottomTabsProps {
  mode: "manual" | "scan";
  onSwitchToManual: () => void;
  onSwitchToScan: () => void;
  t: TranslateFn;
}

export function MobileBottomTabs({ mode, onSwitchToManual, onSwitchToScan, t }: MobileBottomTabsProps) {
  return (
    <div className="ps-bpm-bottom-tabs">
      <button
        type="button"
        className={`ps-bpm-bottom-tab${mode === "manual" ? " ps-active" : ""}`}
        onClick={onSwitchToManual}
      >
        <RulerIcon />
        {t("MANUAL FIT")}
      </button>
      <button
        type="button"
        className={`ps-bpm-bottom-tab${mode === "scan" ? " ps-active" : ""}`}
        onClick={onSwitchToScan}
      >
        <ScanIcon />
        {t("AI SCAN")}
      </button>
    </div>
  );
}
